var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProblem2 = function SvgProblem2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 52,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_2_svg__a)",
    fillRule: "evenodd",
    d: "M6.734 40.598c-2.471 0-4.474 2.038-4.474 4.551s2.003 4.552 4.474 4.552 4.474-2.038 4.474-4.552-2.003-4.551-4.474-4.551M0 45.149c0-3.783 3.015-6.85 6.734-6.85s6.733 3.067 6.733 6.85c0 3.784-3.014 6.851-6.733 6.851C3.014 52 0 48.933 0 45.15",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_2_svg__b)",
    fillRule: "evenodd",
    d: "M44.989 40.598c-2.471 0-4.474 2.038-4.474 4.551s2.003 4.552 4.474 4.552 4.474-2.038 4.474-4.552-2.003-4.551-4.474-4.551m-6.734 4.551c0-3.783 3.015-6.85 6.734-6.85s6.733 3.067 6.733 6.85c0 3.784-3.014 6.851-6.733 6.851-3.72 0-6.734-3.067-6.734-6.85",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_2_svg__c)",
    fillRule: "evenodd",
    d: "M39.385 48.368H12.337V41.93h27.048z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_2_svg__d)",
    fillRule: "evenodd",
    d: "M44.989 40.598c-2.471 0-4.474 2.038-4.474 4.551s2.003 4.552 4.474 4.552 4.474-2.038 4.474-4.552-2.003-4.551-4.474-4.551m-6.734 4.551c0-3.783 3.015-6.85 6.734-6.85s6.733 3.067 6.733 6.85c0 3.784-3.014 6.851-6.733 6.851-3.72 0-6.734-3.067-6.734-6.85",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_2_svg__e)",
    fillRule: "evenodd",
    d: "M83.266 40.598c-2.47 0-4.474 2.038-4.474 4.551s2.003 4.552 4.474 4.552 4.474-2.038 4.474-4.552-2.003-4.551-4.474-4.551m-6.733 4.551c0-3.783 3.014-6.85 6.733-6.85 3.72 0 6.734 3.067 6.734 6.85C90 48.933 86.985 52 83.266 52s-6.733-3.067-6.733-6.85",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_2_svg__f)",
    fillRule: "evenodd",
    d: "M77.64 48.368H50.615V41.93H77.64z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_2_svg__g)",
    fillRule: "evenodd",
    d: "M44.989 2.299c-2.471 0-4.474 2.038-4.474 4.552s2.003 4.551 4.474 4.551 4.474-2.038 4.474-4.551-2.003-4.552-4.474-4.552M38.255 6.85C38.255 3.067 41.27 0 44.99 0s6.733 3.067 6.733 6.85c0 3.784-3.014 6.851-6.733 6.851-3.72 0-6.734-3.067-6.734-6.85",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_2_svg__h)",
    fillRule: "evenodd",
    d: "M48.152 12.552v27.517h-6.327V12.552z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_2_svg__a",
    x1: 45,
    x2: 45,
    y1: 0,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_2_svg__b",
    x1: 45,
    x2: 45,
    y1: 0,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_2_svg__c",
    x1: 45,
    x2: 45,
    y1: 0,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_2_svg__d",
    x1: 45,
    x2: 45,
    y1: 0,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_2_svg__e",
    x1: 45,
    x2: 45,
    y1: 0,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_2_svg__f",
    x1: 45,
    x2: 45,
    y1: 0,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_2_svg__g",
    x1: 45,
    x2: 45,
    y1: 0,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_2_svg__h",
    x1: 45,
    x2: 45,
    y1: 0,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })))));
};
export default SvgProblem2;